var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiBuilding2Fill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5H14V6.5L20.394 9.24C20.574 9.31716 20.7274 9.44548 20.8351 9.60903C20.9428 9.77258 21.0002 9.96416 21 10.16V19.5H23V21.5H1V19.5H3V6.15C2.99998 5.95652 3.05608 5.76718 3.16151 5.60495C3.26695 5.44272 3.41718 5.31455 3.594 5.236L11.297 1.812C11.3732 1.77814 11.4567 1.76389 11.5398 1.77052C11.6229 1.77716 11.7031 1.80448 11.7729 1.85C11.8428 1.89552 11.9002 1.95779 11.9398 2.03115C11.9795 2.1045 12.0002 2.18661 12 2.27V19.5Z",
    fill: "#468EEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiBuilding2Fill);
export default __webpack_public_path__ + "static/media/ri_building-2-fill.167fce85d26e9e91ec4806e7e9ab132e.svg";
export { ForwardRef as ReactComponent };